import * as d3 from 'd3';
import { QuoteChartDto, QuoteChartQueryParamIntervalDto, QuoteDto } from 'src/dtos';
import { Quote, QuoteChart } from 'src/models';

export const mapQuoteChartQueryParamIntervalDtoToChartOptions = (interval: QuoteChartQueryParamIntervalDto) => {
  switch (interval) {
    case QuoteChartQueryParamIntervalDto.OneDay:
      return {
        xAxis: {
          tickInterval: d3.timeHour,
          tickStep: 2,
          tickFormat: 'HH:mm',
        },
      };
    case QuoteChartQueryParamIntervalDto.OneWeek:
      return {
        xAxis: {
          tickInterval: d3.timeDay,
          tickStep: 1,
          tickFormat: 'dddd',
        },
      };
    case QuoteChartQueryParamIntervalDto.OneMonth:
      return {
        xAxis: {
          tickInterval: d3.timeWeek,
          tickStep: 1,
          tickFormat: 'Do MMM',
        },
      };
    case QuoteChartQueryParamIntervalDto.SixMonths:
      return {
        xAxis: {
          tickInterval: d3.timeMonth,
          tickStep: 1,
          tickFormat: 'MMM YYYY',
        },
      };
    case QuoteChartQueryParamIntervalDto.OneYear:
      return {
        xAxis: {
          tickInterval: d3.timeMonth,
          tickStep: 2,
          tickFormat: 'MMM YYYY',
        },
      };
  }
};

export const mapQuoteDtoToModel = (dto: QuoteDto): Quote => ({
  id: dto.Symbol ?? dto.QuoteTime,
  symbol: dto.Symbol ?? '',
  description: dto.Description,
  change: dto.NetChange,
  last: dto.LastTradePrice,
  highPrice: dto.High,
  lowPrice: dto.Low,
  bidPrice: dto.BidPrice,
  openPrice: dto.Open,
  askPrice: dto.AskPrice,
  closePrice: dto.ClosePrice,
  volume: dto.Volume,
  exchange: dto.Exchange,
});

export const mapQuoteChartDtoToModel = (dto: QuoteChartDto): QuoteChart => ({
  date: dto.D,
  closePrice: dto.C,
  highPrice: dto.H,
  lowPrice: dto.L,
  openPrice: dto.O,
  symbol: dto.S,
  volume: dto.V,
});
